export enum ENVIRONMENTS {
	DEFAULT,
	LTI
}

export enum LTI_ENVIRONMENT_MODES {
	DEFAULT,
	COURSE_LEVEL
}
